import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from "react-router-dom";
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { fetchPartners } from 'DBServices/firestoreDBService';
import { motion } from "framer-motion";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
/* import  {
    MenuIcon,
    SearchIcon,
    ShoppingCartIcon,
} from "@heroicons/react/outline"; */
//import { FontAwesomeIcon } from '@fortawesome/fontawesome-free'
//import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { ReactComponent as ShoppingCartIcon } from "images/misc/shopping-cart.svg";
import { ReactComponent as SearchIcon } from "../../images/misc/search.svg";
import logo from "../../images/images/smiles_and_laughters_logo2.png";




//import {SignIn, signOut, useSession} from "";

/* const HeaderRow = tw.div`flex justify-between items-center flex-col xl:flex-row`;
const Header = tw(SectionHeading)``;
const TabsControl = tw.div`flex flex-wrap bg-gray-200 px-2 py-2 rounded leading-none mt-12 xl:mt-0`;

const TabControl = styled.div`
  ${tw`cursor-pointer px-6 py-3 mt-2 sm:mt-0 sm:mr-2 last:mr-0 text-gray-600 font-medium rounded-sm transition duration-300 text-sm sm:text-base w-1/2 sm:w-auto text-center`}
  &:hover {
    ${tw`bg-gray-300 text-gray-700`}
  }
  ${props => props.active && tw`bg-green-500! text-gray-100!`}
  }
`;

const TabContent = tw(motion.div)`mt-6 flex flex-wrap sm:-mr-10 md:-mr-6 lg:-mr-12`;
export const CardContainer = tw.div`mt-10 w-full sm:w-1/2 md:w-1/3 lg:w-1/4 sm:pr-10 md:pr-6 lg:pr-12`;
export const Card = tw(motion.a)`bg-gray-200 rounded-b block max-w-xs mx-auto sm:max-w-none sm:mx-0`;
export const CardImageContainer = styled.div`
  ${props => css`background-image: url("${props.imageSrc}");`}
  ${tw`h-56 xl:h-64 bg-center bg-cover relative rounded-t`}
`;
const Form = tw.form`mx-auto max-w-xs`;
const Input = tw.input`w-full px-8 py-4 rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-sm focus:outline-none focus:border-gray-400 focus:bg-white mt-5 first:mt-0`;
const Select = tw.select`w-full px-8 py-4 rounded-lg font-medium bg-gray-100 border border-gray-200 focus:outline-none font-medium transition duration-300 hocus:border-primary-500`
const SubmitButton = styled.button`
  ${tw`mt-5 tracking-wide font-semibold bg-primary-500 text-gray-100 w-full py-4 rounded-lg hover:bg-primary-900 transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none`}
  .icon {
    ${tw`w-6 h-6 -ml-2`}
  }
  .text {
    ${tw`ml-3`}
  }
`;
const IllustrationContainer = tw.div`sm:rounded-r-lg flex-1 bg-purple-100 text-center hidden lg:flex justify-center`;
const IllustrationImage = styled.div`
  ${props => `background-image: url("${props.imageSrc}");`}
  ${tw`m-12 xl:m-16 w-full max-w-lg bg-contain bg-center bg-no-repeat`}
`;
 */

const HeaderContainer = styled.div`
  ${tw`flex items-center -mx-8 px-8 py-3 shadow-inner flex-grow`}
  background-color: rgba(2, 44, 34, 0.95);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid rgba(6, 78, 59, 0.35);
`;
const HeaderContainerInner = tw.div`lg:hidden md:hidden xl:hidden flex items-center flex-grow sm:flex-grow-0 ml-2`;
const InnerImg = tw.img`cursor-pointer mx-2`;

const MobileSearchIcon = styled(SearchIcon)`
  ${tw`w-6 h-6 cursor-pointer`}
  color: #fbbf24;
  &:hover {
    color: #fcd34d;
  }
`;

const SignInIconDiv = styled.div`
  ${tw`flex items-center text-xs space-x-6 mx-6 whitespace-normal tracking-wide`}
  color: #d1fae5;
`;
const SignInInnerDiv = tw.div`cursor-pointer`;
const SignInInnerP = styled.p`
  ${tw`mb-0 transition-colors duration-200`}
  color: #6ee7b7;
  &:hover {
    color: #fbbf24;
  }
`;
const AnotherP = styled.p`
  ${tw`mt-0 font-bold md:text-sm transition-colors duration-200`}
  color: #f0fdf4;
  &:hover {
    color: #fbbf24;
  }
`;
const RelativeLink = styled.button`
  ${tw`relative flex items-center p-2 rounded-lg transition-colors duration-200`}
  color: #d1fae5;
  &:hover {
    color: #fbbf24;
    background-color: rgba(6, 78, 59, 0.4);
  }
`;
const RelativeLinkSpan = styled.span`
  ${tw`absolute text-center rounded-full font-black text-xs flex items-center justify-center shadow`}
  top: -4px;
  left: -4px;
  height: 18px;
  width: 18px;
  background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);
  color: #0f172a;
`;
const RelativeLinkP = tw.p`hidden md:inline font-extrabold md:text-sm hover:underline ml-2`;
/* const MenuIconContainer = tw.div`flex space-x-3 p-2 pl-6 items-center bg-blue-300 text-white text-sm`;
const MenuIconP = tw.p`flex items-center`;
const PLink = tw.p`hidden lg:inline-flex` */

function HeaderComponent(props) {
    const history = useHistory();
    const items = props.selectItems;
    const session = false;
    const [isPartner, setIsPartner] = useState(false);

    useEffect(() => {
        const auth = getAuth();
        const unsub = onAuthStateChanged(auth, async (u) => {
            if (!u) { setIsPartner(false); return; }
            try {
                const all = await fetchPartners();
                setIsPartner(all.some(p => p.uid === u.uid));
            } catch { setIsPartner(false); }
        });
        return unsub;
    }, []);


    const signIn = () => {return}
    const signOut = () => {return}

    const onClick = () => {
      return;
    }

    return (       
        <div>
            <HeaderContainer>
                {/* <HeaderContainerInner>
                    <InnerImg
                        onClick = {() => history.replace('/')}
                        src={logo}
                        width={50}
                        height={20}
                        style={{objectFit: "contain"}}
                        className="cursor-pointer"
                        alt='company logo'
                    />
                </HeaderContainerInner> */}

                <HeaderContainerInner>
                  <MobileSearchIcon onClick={() => history.push('/marketplace')} />
                </HeaderContainerInner>



                {/* Right */}
                <SignInIconDiv>
                    <SignInInnerDiv onClick={() => isPartner ? history.push('/partner') : (!session ? signIn() : signOut())} className="link">
                        <SignInInnerP>
                            {session ? `Hello, ${session?.user?.name}` : "Sign In"}
                        </SignInInnerP>
                        <AnotherP>{isPartner ? 'Dashboard' : 'Account & Lists'}</AnotherP>
                    </SignInInnerDiv>
                    <SignInInnerDiv onClick={() => history.push('/history')} className="link">
                      <SignInInnerP>
                          History
                        </SignInInnerP>
                        <AnotherP>& Orders</AnotherP>
                    </SignInInnerDiv>
                    <RelativeLink onClick = {() => history.push('/checkout')} className='link'>
                        <RelativeLinkSpan>{items.length}</RelativeLinkSpan>
                        <ShoppingCartIcon style={{marginLeft: 12}} />
                        {/*<ShoppingCartIcon className="h-10" />*/}
                        <RelativeLinkP>Basket</RelativeLinkP>
                    </RelativeLink>
                </SignInIconDiv>
            </HeaderContainer>


            {/*<MenuIconContainer>
                <MenuIconP className='link'>
                    <MenuIcon className="h-6 mr-1" />
                    All
                </MenuIconP>
                <p className="link">Prime Video</p>
                <p className="link">Amazon Business</p>
                <p className="link">Today's Deals</p>
                <p className="link">Electronics</p>
                <PLink className="link">Food & Grocery</PLink>
                <PLink className="link">Prime</PLink>
                <PLink className="link">Buy Again</PLink>
                <PLink className="link">Shopper Toolkit</PLink>
                <PLink className="link">Health & Personal Care</PLink>
            </MenuIconContainer>*/}
        </div>
    )
}

const Header = connect((state) => ({
    selectItems: state.TabCardGridData.items,
  }), (dispatch) => ({
    /*fetchMainStocks: async () => {        
      return fetchMarketData().then((data) => {       
        dispatch(fetchMainStocks(data));
      });
    },
    onClick: (tabName) => {
      tabName === 'Market' ? dispatch(setTabAction('Coming Soon')) : dispatch(setTabAction(tabName));
    }*/ 
  }))(HeaderComponent);

export default Header
